import React, { useEffect, useCallback } from 'react';
// redux
// import { useDispatch } from '../redux/store';
// import { setToken1, setToken2, setToken3, setToken4, setToken5 } from '../redux/slices/dagpacket';
// firestore
import { firestore } from './FirebaseContext';
import PropTypes from 'prop-types';

TokensCore.propTypes = {
  children: PropTypes.node.isRequired
};

export default function TokensCore({ children }) {
  // const dispatch = useDispatch();

  const getTokens = useCallback(async () => {
    // await firestore
    //  .collection('tokens')
    //  .get()
    //  .then((snapshot) => snapshot.docs.map((doc) => doc.data().token));
  }, []);

  useEffect(() => {
    getTokens();
  }, [getTokens]);
  return <>{children}</>;
}
